import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'
import { useMemo } from 'react'

type ChangingAccountantWelcomeMessageProps = DialogProps & {
  engagementDate?: string
  onClose: () => void
}

const bodyTextSx = { fontSize: { xs: '14px', md: '16px' } }

export function ChangingAccountantWelcomeMessage({
  onClose,
  ...dialogProps
}: ChangingAccountantWelcomeMessageProps) {
  const { currentYear, previousYear } = useMemo(() => {
    const currentYear = new Date().getFullYear()

    return {
      currentYear,
      previousYear: currentYear - 1,
    }
  }, [])

  return (
    <Dialog {...dialogProps}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ fontSize: '24px' }}>🎉</Box>
        Boas vindas à Alume!
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          <Typography variant="body2" sx={bodyTextSx}>
            É uma satisfação iniciar esta parceria com você. Aqui, prezamos pela segurança das informações e pela regularidade de todos os processos, e por isso seguimos um rigoroso padrão de conferência na entrada de novos clientes.
          </Typography>
          <Typography variant="body2" sx={bodyTextSx}>
            Para começarmos a cuidar da sua contabilidade com todo cuidado e
            precisão que ela merece, precisamos que você nos envie alguns
            documentos essenciais:
          </Typography>
          <Box
            component="ul"
            sx={{
              listStyle: 'inside',
              pl: 1,
              m: 0,
              '& li': bodyTextSx,
            }}
          >
            <li>
              Balanço Patrimonial: referente ao ano de {previousYear}.
            </li>
            <li>
              Balanço Patrimonial: referente aos meses de {currentYear}{' '}
              anteriores ao início da nossa responsabilidade.
            </li>
            <li>DRE: referente ao ano de {previousYear}.</li>
            <li>
              DRE: referente aos meses de {currentYear} anteriores ao início da
              nossa responsabilidade.
            </li>
            <li>
              Balancete de Verificação: referente aos meses de {currentYear}{' '}
              anteriores ao início da nossa responsabilidade.
            </li>
            <li>
              Composição de Saldos: Imobilizado, Impostos a Recuperar e
              Adiantamento de Clientes (se houver).
            </li>
            <li>
              Memórias de Cálculo: apenas se a empresa for Lucro Presumido.
            </li>
            <li>Recibos de Pró-Labore: dos últimos 12 meses.</li>
          </Box>
          <Typography variant="body2" sx={bodyTextSx}>
            Quanto antes recebermos esses documentos, mais rápido conseguimos
            conferir tudo com atenção e garantir que sua empresa esteja regular.
          </Typography>
          <Typography variant="body2" sx={bodyTextSx}>
            Ficamos à disposição para esclarecer qualquer dúvida!
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
